"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recaptchaResponse = void 0;
const $ = require("jquery");
let RecaptchaFooter;
let siteKey = document.querySelector('.g-recaptcha').getAttribute('data-sitekey');
window.onloadCallback = () => {
    RecaptchaFooter = grecaptcha.render('RecaptchaFooter', {
        'sitekey': siteKey,
        'callback': exports.recaptchaResponse
    });
};
let isRecaptchaValid = false;
let captchaMessage = 'Please verify that you are not a robot.';
const recaptchaResponse = () => {
    $('.captcha').removeClass('error');
    $('.error-captcha').remove();
    if (grecaptcha.getResponse(RecaptchaFooter).length === 0) {
        isRecaptchaValid = false;
        $('#RecaptchaFooter').after('<span class="diallingCode-error error-captcha">' + captchaMessage + '</span>');
        return false;
    }
    else {
        return true;
    }
};
exports.recaptchaResponse = recaptchaResponse;
